import ScalarMenuButton_vue_vue_type_script_setup_true_lang_default from "./ScalarMenuButton.vue.script.js";
//#region src/components/ScalarMenu/ScalarMenuButton.vue
var ScalarMenuButton_default = ScalarMenuButton_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarMenuButton_default as default };

//# sourceMappingURL=ScalarMenuButton.vue.js.map